import React, { Fragment } from 'react';
import ArrowForward from '@material-ui/icons/ArrowForward';
import { formatStatValue } from './utils';

// Three coarse buckets; each aggregates server-side counts for finer return stages.
const RETURN_BUCKETS = [
    {
        label: 'Inbound',
        keys: ['return_created_count', 'return_in_transit_count'],
    },
    {
        label: 'On-Hand',
        keys: ['return_pending_put_away_count', 'return_stored_count', 'return_trailer_scheduled_count'],
    },
    {
        label: 'Outbound',
        keys: ['return_picked_count', 'return_staged_count', 'return_loaded_count'],
    },
];

// Above statuses are determined by:
// - Return - Created — return exists, pickup not scheduled yet
// - Return - In-Transit — pickup scheduled / en route back to warehouse
// - Return - Pending Put Away — return received at dock, not yet stored
// - Return - Stored — return placed in inventory/storage
// - Return - Trailer Scheduled — return trailer booked for outbound leg (return order scheduled)
// - Return - Picked — pulled from storage for the return trailer
// - Return - Staged — staged at the door awaiting loading
// - Return - Loaded — on the return trailer, leaving the network

const bucketTotal = (summary, keys) =>
    keys.reduce((sum, key) => {
        const value = summary?.[key];
        return value === null || value === undefined ? sum : sum + value;
    }, 0);

// Undefined rather than 0 while the summary is absent, so formatStatValue can
// render its loading state instead of a confident zero.
const bucketValue = (summary, keys) => (summary ? bucketTotal(summary, keys) : undefined);

const ReturnsOverview = ({ summary, loading, error }) => {
    if (error) {
        return null;
    }

    const status = { loading, error };
    // Read from its own column rather than summing the eight cards below, so
    // the total can independently confirm (or contradict) that the cards add
    // up to it instead of being defined as their sum.
    const total = summary ? summary.return_count : undefined;

    return (
        <div className="shrink-0 pb-4">
            <h2 className="pb-3.5 text-lg font-semibold text-[#1a1a1a]">Returns Overview</h2>
            <div className="flex items-center gap-[5px]">
                <div className="flex flex-1 flex-col items-center gap-1 rounded-xl border border-[#c7d2fe] bg-[#6d28d9] px-5 py-4">
                    <p className="text-4xl font-bold text-[#f5f3ff]">{formatStatValue(total, status)}</p>
                    <p className="text-sm text-[#f5f3ff] opacity-80">Total Returns</p>
                </div>
                {RETURN_BUCKETS.map(({ label, keys }) => (
                    <Fragment key={label}>
                        <ArrowForward className="shrink-0 text-[rgba(185,185,185,0.87)]" />
                        <div className="flex flex-1 flex-col items-center gap-1 rounded-xl border border-[#c7d2fe] bg-[#f5f3ff] px-5 py-4">
                            <p className="text-4xl font-bold text-[#6d28d9]">
                                {formatStatValue(bucketValue(summary, keys), status)}
                            </p>
                            <p className="text-sm text-[#6d28d9] opacity-80">{label}</p>
                        </div>
                    </Fragment>
                ))}
            </div>
        </div>
    );
};

export default ReturnsOverview;
